var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatutGrisComplexe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,7.4c2.5,0,4.6,2.1,4.6,4.6s-2.1,4.6-4.6,4.6S7.4,14.5,7.4,12l0,0C7.4,9.5,9.5,7.4,12,7.4 M12,9.7c-1.3,0-2.3,1-2.3,2.3 s1,2.3,2.3,2.3s2.3-1,2.3-2.3S13.3,9.7,12,9.7L12,9.7 M9.7,23.5c-0.3,0-0.5-0.2-0.6-0.5l-0.4-3c-0.7-0.3-1.4-0.7-1.9-1.1L3.9,20 c-0.3,0.1-0.6,0-0.7-0.3l-2.3-4C0.7,15.5,0.8,15.2,1,15l2.4-1.9L3.4,12l0.1-1.1L1,9C0.8,8.8,0.7,8.5,0.9,8.3l2.3-4 C3.3,4,3.6,3.9,3.9,4l2.9,1.2C7.3,4.7,8,4.3,8.7,4l0.4-3c0-0.3,0.3-0.5,0.6-0.5h4.6c0.3,0,0.5,0.2,0.6,0.5l0.4,3 c0.7,0.3,1.3,0.7,1.9,1.1L20.1,4c0.3-0.1,0.6,0,0.7,0.3l2.3,4C23.3,8.5,23.2,8.8,23,9l-2.4,1.9l0.1,1.1l-0.1,1.1L23,15 c0.2,0.2,0.3,0.5,0.1,0.7l-2.3,4c-0.1,0.2-0.4,0.4-0.7,0.3l-2.9-1.1c-0.6,0.5-1.3,0.9-2,1.2l-0.4,3c0,0.3-0.3,0.5-0.6,0.5L9.7,23.5  M11.1,2.8l-0.4,3c-1.4,0.3-2.6,1-3.5,2L4.4,6.7L3.6,8.1L6,9.9c-0.5,1.3-0.5,2.8,0,4.1l-2.4,1.8l0.9,1.5l2.8-1.2 c0.9,1,2.1,1.7,3.5,2l0.4,3h1.8l0.4-3c1.3-0.3,2.6-1,3.5-2l2.8,1.2l0.9-1.5L18,14.1c0.5-1.3,0.5-2.8,0-4.1l2.4-1.8l-0.9-1.5 l-2.8,1.2c-0.9-1-2.1-1.7-3.5-2l-0.4-3L11.1,2.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatutGrisComplexe);
export default __webpack_public_path__ + "static/media/statut_gris_complexe.c290986a.svg";
export { ForwardRef as ReactComponent };